import styles from "./chart.module.css"

import React from "react"
import * as recharts from "recharts"
import * as util from "activities/util"
import * as chartUtil from "activities/components/charts/util"
import * as fonts from "shared/fonts"

// DATA STRUCTURE for Chart
// const chartData = {
//   legend: {
//     x: {
//       label: "Years",
//       key: "year"
//     },
//     y: {
//       label: "Balance",
//       type: "currency"
//     }
//   },
//   fields: {
//     "year": {type: "number", tooltip: {title: "Year", order: 0}},
// "balance": {
//   type: "currency",
//   tooltip: {
//     title: "Balance", order: 1, color: "color-1"
//   }
// }
//   },
//   values: {
//     x: number for x axis,
//     y: array of objects for recharts
//   }
// }

export default ({data, theme, ariaLabel}) => {
  if (!data) {
    return null
  }
  const rechartsArray = data.values.y
  const key = data.legend.x.key
  const rowCount = Object.keys(data.fields).length

  return (
    <div className={styles["chart"]} aria-label={ariaLabel}>
      <chartUtil.AxisLabel label="Balance" axis="yaxis" />
      <recharts.ResponsiveContainer width={"100%"} height={"100%"}>
        <recharts.LineChart data={rechartsArray}>
          <recharts.XAxis
            dataKey={key}
            interval={0}
            axisLine={false}
            tickLine={false}
            ticks={util.getScreenWidth() < 620 || rechartsArray.length > 20 ? chartUtil.getXAxisTicks(key, rechartsArray) : []}
            tick={chartUtil.tickStyles}
          />
          <recharts.YAxis
            type="number"
            domain={[0, "dataMax"]}
            axisLine={false}
            tickLine={false}
            tickFormatter={(tick) => util.formatDollarsNoCents(tick)}
            tick={chartUtil.tickStyles}
          />
          <recharts.Line
            type="monotone"
            dataKey="balance"
            stroke={"#" + theme["color-1"]}
            strokeWidth={2}
            activeDot={{stroke: "#" + theme["color-1"], strokeWidth: 2, r: 4}}
            isAnimationActive={false}
          />
          <recharts.Tooltip cursor={false} content={<chartUtil.CustomTooltip data={data} theme={theme} />} wrapperStyle={chartUtil.tooltipStyles(rowCount)} />
        </recharts.LineChart>
      </recharts.ResponsiveContainer>
      <chartUtil.AxisLabel label={data.legend.x.label} axis="xaxis" />
    </div>
  )
}
